export const defaultTableCells = [
  {
    title: 'Practice Management Charge Description',
    label: 'Practice Management Charge Description',
    fieldName: 'charge_code_name',
    sortField: 'charge_code_name_sort',
    display: true,
  },
  {
    title: 'Product Name',
    label: 'Product Name',
    fieldName: 'product_catalog_name',
    sortField: 'product_catalog_name_sort',
    display: true,
  },
  {
    title: 'Change Mapping',
    label: 'Change Mapping',
    align: 'text-center',
    width: '80px',
    display: true,
  },
  {
    title: 'SKU',
    label: 'SKU',
    fieldName: 'product_sku',
    sortField: 'product_sku_sort',
    display: true,
  },
  {
    title: '<span>Revenue <span class="whitespace-no-wrap">Category 1</span></span>',
    label: 'Revenue Category 1',
    fieldName: 'product_category1',
    sortField: 'product_category1_sort',
    display: true,
  },
  {
    title: '<span>Revenue <span class="whitespace-no-wrap">Category 2</span></span>',
    label: 'Revenue Category 2',
    fieldName: 'product_category2',
    sortField: 'product_category2_sort',
    display: true,
  },
  {
    title: '<span>Revenue <span class="whitespace-no-wrap">Category 3</span></span>',
    label: 'Revenue Category 3',
    fieldName: 'product_category3',
    sortField: 'product_category3_sort',
    display: false,
  },
  {
    title: '<span>Revenue <span class="whitespace-no-wrap">Category 4</span></span>',
    label: 'Revenue Category 4',
    fieldName: 'product_category4',
    sortField: 'product_category4_sort',
    display: false,
  },
  {
    title: 'Brand',
    label: 'Brand',
    fieldName: 'product_brand',
    sortField: 'product_brand_sort',
    display: true,
  },
  {
    title: 'Manufacturer',
    label: 'Manufacturer',
    fieldName: 'product_manufacturer',
    sortField: 'product_manufacturer_sort',
    display: true,
  },
  {
    title: 'Loyalty Program',
    label: 'Loyalty Program',
    fieldName: 'loyalty_program',
    sortField: 'product_loyalty_program_sort',
    display: true,
  },
  {
    title: 'Action',
    label: 'Action',
    align: 'text-center',
    display: false,
  }
];

export const searchFields = [
  {
    name: 'Product Name',
    value: 'product_catalog_name'
  },
  {
    name: 'Brand',
    value: 'product_brand'
  },
  {
    name: 'SKU',
    value: 'product_sku'
  },
  {
    name: 'Revenue Category 1',
    value: 'product_category1'
  },
  {
    name: 'Revenue Category 2',
    value: 'product_category2'
  },
];
